module.exports = __webpack_public_path__ + "static/Biotif-Regular-40dfdecd54f1dbbd879970893e736a88.woff";